import { AverageHoldingTime, AverageReturn } from './components/AverageStats'
import { Overview } from './components/Overview'
import { PopularTrades } from './components/PopularTrades'
import { TopTrades } from './components/TopTrades'
import { YourMarkets } from './components/YourMarkets'
import s from './styles.module.scss'
import {useEffect} from "react";
import {asyncGetOverallAnalytics} from "@Redux/slices/reports/ReportsSlice";
import {useAppSelector} from "@App/hooks";
import {currentWallet} from "@Redux/slices/user/selectors";
import {useDispatch} from "react-redux";
import {
  getTimestampFromPeriod,
  ReportsFilter,
  ReportsFilters
} from "@UI/crypto_exchange/desktop/pages/spot/components/Reports/model";
export const Analytics = ({ filters }: {filters: ReportsFilter}) => {
  const wallet = useAppSelector(currentWallet)
  const dispatch = useDispatch()
  const timestampFrom = getTimestampFromPeriod(filters.period)

  useEffect(() => {
    if (!wallet?.id) return
    dispatch(asyncGetOverallAnalytics(
      {timestampFrom, timestampTo: null}
    ))
  }, [wallet?.id, filters.period])

  return (
    <div className={s.container}>
      <div className={s.left}>
        <Overview />
        <AverageHoldingTime />
        <AverageReturn />
      </div>
      <div className={s.right}>
        <TopTrades filters={filters} />
        <YourMarkets filters={filters}/>
        <PopularTrades filters={filters}/>
      </div>
    </div>
  )
}
